import { render, staticRenderFns } from "./AlbumTopMatter.vue?vue&type=template&id=3f9bb603"
import script from "./AlbumTopMatter.vue?vue&type=script&lang=ts"
export * from "./AlbumTopMatter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports